import { apiClient } from "@nabble/sdk";

export interface Policies {
  passwordMinLength: number;
  sessionIdleMinutes: number;
  sessionMaxHours: number;
  lockoutMaxFailures: number;
  lockoutMinutes: number;
  auditRetentionDays: number;
  logsRetentionDays: number;
  backupRetentionDays: number;
  /** "Keep me signed in" lifetime in days; 0 turns the option off (maximum 30). */
  rememberMeDays: number;
}

export interface PoliciesResponse {
  current: Policies;
  defaults: Policies;
}

export function fetchPolicies(): Promise<PoliciesResponse> {
  return apiClient<PoliciesResponse>("/api/admin/policies");
}

export function savePolicies(policies: Policies): Promise<void> {
  return apiClient<void>("/api/admin/policies", { method: "PUT", body: policies });
}
